// ConditionsGeneralesPage.js
import React, { useState } from 'react';
import Breadcrumbs from 'components/common/Breadcrumbs';
import BannerWithSocialIcons from 'components/common/BannerWithSocialIcons';
import styles from './ContactPage.module.css';
import legalStyles from 'styles/modules/legalsPage.module.css';
import sharedStyles from 'styles/modules/ContentPage.module.css';
import useDesignSettingsData from 'hooks/useDesignSettingsData';
import { Helmet } from 'react-helmet';

const ConditionsGenerales = () => {

  const { designSettings, settingsLoading, error } = useDesignSettingsData();

  return (
    <>
      <Helmet>
        <title>Arras | Conditions générales</title>
        <meta name="description" content="Consultez les conditions générales d'utilisation de notre site pour connaître les règles, droits et obligations applicables. Transparence et respect des normes légales garanties." />
        <meta property="og:title" content="Arras | Conditions générales" />
        <meta property="og:description" content="Découvrez les conditions générales d'utilisation du site arras.fr, incluant les droits, devoirs et responsabilités des utilisateurs et de l'éditeur." />
        <link rel="canonical" href={`https://www.arras.fr/conditions-generales`} />
      </Helmet>
      <div className={`${styles.contactPage} ${styles.legalsPage} ${sharedStyles.pageWrapper}`}>
        <div className={`page-content ${sharedStyles.pageContent}`}>
          <section className={`global-section global-section-title ${sharedStyles.section}`}>
            <div className={`global-container ${styles.content}`}>
              <div>
                <h1>Conditions générales</h1>
                {/* Fil d'Ariane */}
                <Breadcrumbs pageType="isPage" element={{ title: "Conditions générales" }} />
              </div>
            </div>
          </section>
          <section className={`global-section ${sharedStyles.mainSection}`}>
            <div className={`global-container ${styles.main}`}>
              <div className={`${styles.block} ${legalStyles.content}`}>
                <h3><a href="https://arras.fr" aria-label="Accéder au site de la ville d'Arras">arras.fr</a> est le site officiel de la Ville d’Arras</h3>

                <h2>MAIRIE D'ARRAS</h2>
                <address>
                  Place Guy Mollet<br />
                  BP 70913 - 62022 ARRAS Cedex<br />
                  Tél : <a href="tel:+33321505050">03 21 50 50 50</a><br />
                  Fax : 03 21 50 50 00<br />
                </address>
              </div>


            </div>
          </section>
        </div >
      </div >
    </>
  );
};

export default ConditionsGenerales;
